import React, { ReactNode } from 'react';
import { IconCheck } from '../components/svgs';

interface SuccessProps {
  children: Element | ReactNode;
}
export const Success: React.FC<SuccessProps> = ({ children }) => {
  return (
    <div style={{ padding: '20px 0' }} className="tda__questionResult tda__questionResult--success">
      <IconCheck />
      {children}
    </div>
  );
};
